import { ExpandOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import { Col, Row, theme } from "antd";
import React, { PropsWithChildren, useEffect, useRef, useState } from "react";
import { Flex } from "src/components/Flex";

export const Section = (
  props: PropsWithChildren<{
    title?: React.ReactElement | string;
    style?: React.CSSProperties;
    expandable?: boolean;
    expanded?: boolean;
    maxHeight?: number;
    vzbl?: boolean;
    isEmpty?: boolean;
  }>
) => {
  const { token } = theme.useToken();
  const [expanded, setExpanded] = useState(
    props.expanded === undefined ? false : props.expanded
  );
  const [expandable, setExpandable] = useState(props.expandable || false);
  const contentRef = useRef<HTMLDivElement>(null);
  const children = props.children;
  const maxHeight = props.maxHeight || 150;

  const toggleExpand = () => {
    setExpanded(!expanded);
    return false;
  };
  useEffect(() => {
    if (expandable) {
      const clientHeight = contentRef.current?.clientHeight || 0;
      if (clientHeight < maxHeight) {
        setExpandable(false);
        setExpanded(true);
      }
    } else {
      setExpanded(true);
    }
  }, [children, contentRef, maxHeight, expandable]);

  const emptyStyle: React.CSSProperties = { color: token.colorTextTertiary };
  return (
    <div
      style={{
        overflow: expandable ? "hidden" : "visible",
        position: "relative",
        maxHeight: expanded ? "unset" : maxHeight,
      }}
    >
      {props.title && (
        <Row
          className="section-header"
          align="middle"
          style={
            props.vzbl
              ? { backgroundColor: `${token.colorPrimary}22` }
              : { backgroundColor: token.colorBgLayout }
          }
        >
          <Col span={24}>
            <Flex spaceBetween style={{ color: token.colorText }}>
              <div
                style={props.isEmpty ? emptyStyle : { color: token.colorText }}
              >
                {props.title}
              </div>
              {expandable && (
                <div
                  onClick={toggleExpand}
                  style={{
                    cursor: "pointer",
                  }}
                  className="fakeLink"
                >
                  {expanded ? (
                    <>
                      <FullscreenExitOutlined /> See less
                    </>
                  ) : (
                    <>
                      <ExpandOutlined /> See more
                    </>
                  )}
                </div>
              )}
            </Flex>
          </Col>
        </Row>
      )}
      <Row className="section" style={props.style}>
        <Col span={24} ref={contentRef} className="entity">
          {props.children}
        </Col>
      </Row>
      {expandable && !expanded && (
        <div
          style={{
            background: `linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, ${token.colorBgContainer} 100%)`,
            height: "50%",
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
          }}
        />
      )}
    </div>
  );
};

export const SectionSubHeader = (props: PropsWithChildren<{}>) => {
  const { token } = theme.useToken();
  return (
    <div className="entity" style={{ color: token.colorTextTertiary }}>
      {props.children}
    </div>
  );
};
